import request from '@/plugins/request';

/**
 * 获取二维码列表
 * @returns {Promise} - 返回Promise对象
 */
export function getQrList() {
  return request({
    url: '/fronted/qr/list',
    method: 'get'
  });
} 